function accordionSideImageA11Y() {
	const accordionSideImage = document.querySelector('.block-accordion-side-image');
	const accordionContents = accordionSideImage.querySelectorAll('.block-content');
	const accordionButtons = accordionSideImage.querySelectorAll('.wp-block-button.is-style-accordion .wp-block-button__link');

	function updateFocusableElements(container) {
		const focusables = container.querySelectorAll(
			'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
		);

		for (let i = 0; i < focusables.length; i++) {
			if (container.classList.contains('DOM-slider-hidden')) {
				focusables[i].setAttribute('tabindex', '-1');
			} else {
				focusables[i].removeAttribute('tabindex');
			}
		}
	}

	accordionContents.forEach((hiddenContainer) => {
		updateFocusableElements(hiddenContainer);
	});

	accordionButtons.forEach((button) => {
		button.addEventListener('click', (event) => {
			const blockContent = event.target.parentElement.nextElementSibling;

			for (let i = 0; i < accordionContents.length; i++) {
				const focusables = accordionContents[i].querySelectorAll(
					'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
				);

				if (accordionContents[i] === blockContent) {
					for (let j = 0; j < focusables.length; j++) {
						focusables[j].removeAttribute('tabindex');
					}
				} else {
					for (let j = 0; j < focusables.length; j++) {
						focusables[j].setAttribute('tabindex', '-1');
					}
				}
			}
		});
	});
}

const accordionImageContents = document.querySelectorAll(
	'.block-accordion-side-image__content'
);

const resizeGrid = () => {
	if (accordionImageContents.length) {
		accordionImageContents.forEach((accordionContent) => {
			accordionContent.style.removeProperty('--marginTop');
			accordionContent.nextElementSibling?.style.removeProperty(
				'--marginTop'
			);

			const offset =
				accordionContent.offsetTop -
				accordionContent.nextElementSibling?.offsetTop;

			if (offset > 0) {
				accordionContent.style.setProperty(
					'--marginTop',
					`${offset}px`
				);
			} else {
				accordionContent.style.setProperty('--marginTop', `0px`);
			}
		});
	}
};

function getPreviousColor() {
	const accordionSideImage = document.querySelector('.block-accordion-side-image');
	const previousSibling = accordionSideImage.previousElementSibling;
	const lightInnerClasses = ['bg-white', 'bg-transparent'];

	if (
		previousSibling &&
		previousSibling.classList.contains('acf-block')
	) {
		for (let i = 0; i < previousSibling.classList.length; i++) {
			if (previousSibling.classList[i].startsWith('bg-')) {
				const accordionContent = accordionSideImage.querySelector('.block-accordion-side-image__content');
				let classToAdd = previousSibling.classList[i];

				accordionSideImage.classList.remove('bg-transparent');
				accordionSideImage.classList.remove('bg-white');
				if (classToAdd === 'bg-transparent') classToAdd = 'bg-white';
				accordionSideImage.classList.add(classToAdd);

				if (!lightInnerClasses.includes(classToAdd)) {
					accordionContent.classList.add('bg-white');
				} else {
					accordionContent.classList.add('bg-green');

					const accordionItems = accordionContent.querySelectorAll('.bg-transparent, .bg-white');

					accordionItems.forEach((accordionItem) => {
						accordionItem.classList.remove('bg-white');
						accordionItem.classList.remove('bg-transparent');
					});
				}

				break;
			}
		}
	} else {
		const accordionContent = accordionSideImage.querySelector('.block-accordion-side-image__content');
		accordionContent.classList.add('bg-green');
	}
}

const accordions = () => {
	if (accordionImageContents.length) {
		resizeGrid();
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		getPreviousColor();
		accordions();
	},
	loaded() {
		accordionSideImageA11Y();
	},
	resized() {
		resizeGrid();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
